import { render } from "./IconCalendarBlank.vue?vue&type=template&id=0bf3ffab"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__